import React, {Component} from 'react';
import {
    Button,
    InputLabel,
    TextField,
    withStyles,
    DialogActions,
    DialogContent,
    DialogTitle,
    Chip,
    Divider,
    Grid,
} from 'material-ui';
import {EditDialog} from '../../../../components/edit-dialog/edit_dialog';
import {styles} from '../../style/staff_section';
import SimpleEditor from '../../../../components/editor/simple_editor';
import PagePicker from '../../../page-picker/page_picker';

export class MeetUsSectionEdit extends Component {
    state = {
        selectedPickPicker: 'events',
    };

    handlePickerPickerChange = (value) => {
        this.setState({
            selectedPickPicker: value,
        });
    };

    render() {
        let {
            open,
            title,
            body,
            eventsPage,
            meetingsBody,
            meetingsPage,
            careersBody,
            careersPage,
            onHandleClose,
            onUpdateTitleField,
            onUpdateBodyField,
            onUpdateMeetingsBodyField,
            onUpdateCareersBodyField,
            onHandleSubmit,
            classes,
            closePagePicker,
            onPickEventsPage,
            onPickMeetingsPage,
            onPickCareersPage,
        } = this.props;

        let {selectedPickPicker} = this.state;

        let onPageSelect = onPickEventsPage;

        if (selectedPickPicker && selectedPickPicker === 'meetings') {
            onPageSelect = onPickMeetingsPage;
        } else if (selectedPickPicker && selectedPickPicker === 'careers') {
            onPageSelect = onPickCareersPage;
        }

        let eventsPageTitle = 'None Selected';
        if (eventsPage && eventsPage.title) {
            eventsPageTitle = eventsPage.title;
        }

        let meetingsPageTitle = 'None Selected';
        if (meetingsPage && meetingsPage.title) {
            meetingsPageTitle = meetingsPage.title;
        }

        let careersPageTitle = 'None Selected';
        if (careersPage && careersPage.title) {
            careersPageTitle = careersPage.title;
        }

        return (
            <div>
                <EditDialog
                    open={open}
                    classes={{
                        paper: classes.paper,
                        fullWidth: classes.fullWidth,
                    }}
                >
                    <DialogTitle>Edit Meet Us Section</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={0}>
                            <Grid item xs={12}>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    id="title"
                                    label="Title"
                                    onChange={(event) => {
                                        onUpdateTitleField(event.target.value);
                                    }}
                                    fullWidth
                                    value={title || ''}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Chip
                                    className={
                                        classes.sectionMeetUsPageLinkChip
                                    }
                                    label={
                                        'Link to Events Page *: ' +
                                        eventsPageTitle
                                    }
                                    onClick={() => {
                                        this.handlePickerPickerChange('events');
                                        this.props.openPagePicker();
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <InputLabel className="simpleEditorLabelPages">
                                    Events Body
                                </InputLabel>
                                <SimpleEditor
                                    initialValue={body}
                                    onChange={(htmlBody) => {
                                        onUpdateBodyField(htmlBody);
                                    }}
                                />
                                <Divider />
                            </Grid>

                            <Grid item xs={12}>
                                <Chip
                                    className={
                                        classes.sectionMeetUsPageLinkChip
                                    }
                                    label={
                                        'Link to Meetings Page *: ' +
                                        meetingsPageTitle
                                    }
                                    onClick={() => {
                                        this.handlePickerPickerChange(
                                            'meetings'
                                        );
                                        this.props.openPagePicker();
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <InputLabel className="simpleEditorLabelPages">
                                    Meetings Body
                                </InputLabel>
                                <SimpleEditor
                                    initialValue={meetingsBody}
                                    onChange={(htmlBody) => {
                                        onUpdateMeetingsBodyField(htmlBody);
                                    }}
                                />
                                <Divider />
                            </Grid>

                            <Grid item xs={12}>
                                <Chip
                                    className={
                                        classes.sectionMeetUsPageLinkChip
                                    }
                                    label={
                                        'Link to Careers Page *: ' +
                                        careersPageTitle
                                    }
                                    onClick={() => {
                                        this.handlePickerPickerChange(
                                            'careers'
                                        );
                                        this.props.openPagePicker();
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <InputLabel className="simpleEditorLabelPages">
                                    Careers Body
                                </InputLabel>
                                <SimpleEditor
                                    initialValue={careersBody}
                                    onChange={(htmlBody) => {
                                        onUpdateCareersBodyField(htmlBody);
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className={classes.dialogActionsBtn}>
                        <Button
                            variant="raised"
                            onClick={(ev) => onHandleClose(ev)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="raised"
                            onClick={(ev) => onHandleSubmit(ev)}
                            color="primary"
                        >
                            Done
                        </Button>
                    </DialogActions>

                    <PagePicker
                        open={this.props.sectionPagePickerPopupOpen}
                        handleClose={closePagePicker}
                        onPick={(pageId, pageTitle) => {
                            onPageSelect(pageId, pageTitle);
                            closePagePicker();
                        }}
                        searchString={this.props.pageSearchCriteria}
                        onSearchPages={(event) => {
                            this.props.onSearchPages(
                                event.target.value,
                                this.props.siteId
                            );
                        }}
                        allPagesBySearchCriteria={
                            this.props.allPagesBySearchCriteria
                        }
                    />
                </EditDialog>
            </div>
        );
    }
}

export default withStyles(styles)(MeetUsSectionEdit);



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/meet_us_section_edit.js